import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

// import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import NewsSlider from "./components/news-slider";
import FrontPageHorsesSlider from "./components/horses-slider";
import ImagesSlider from "./components/images-slider";
import VideoSlider from './components/video-slider';
import PartnersSlider from "./components/partners-slider";
import PortalPageSlider from "./components/portal-page-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import Gallery from "./components/gallery";
import NewsletterForm from "./components/newsletter-form";
import ScrollInView from "./components/scroll-in-view";
import HorsesSlider from './components/related-horses-slider';
import HorsesFilter from "./components/horses-filters";
import BacktoTop from "./components/back-to-top";

import DeviceManager from "./utils/device-manager";

// (function ($) {
	// window.$ = $;

$(function () {

	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		// const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Home slider component
		const $homesSliders = $(".homepage-slider");
		if ($homesSliders.length) {
			$homesSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// News slider component
		const $newsSliders = $(".last-news-section__slider");
		if ($newsSliders.length) {
			$newsSliders.each(function (index, el) {
				const newsSlider = new NewsSlider($(el));
			});
		}

		// Horses slider component
		const $frontPagehorsesSliders = $(".front-page__horse-list");
		if ($frontPagehorsesSliders.length) {
			$frontPagehorsesSliders.each(function (index, el) {
				const frontPagehorsesSlider = new FrontPageHorsesSlider($(el));
			});
		}

		// Partners slider component
		// const $partnersSliders = $(".section-partners__content__slider");
		// if ($partnersSliders.length) {
		// 	$partnersSliders.each(function (index, el) {
		// 		const partnerSlider = new PartnersSlider($(el));
		// 	});
		// }

		// Images slider component
		const $imagesSlider = $(".section-slider__images");
		if ($imagesSlider.length) {
			$imagesSlider.each(function (index, el) {
				const imagesSlider = new ImagesSlider($(el));
			});
		}

		// Videos slider component
		const $videoSlider = $(".section-slider__video");
		if ($videoSlider.length) {
			$videoSlider.each(function (index, el) {
				const videoSlider = new VideoSlider($(el));
			});
		}

		// Other horses slider component
		const $horsesSlider = $(".other-horses__slider");
		if ($horsesSlider.length) {
			$horsesSlider.each(function (index, el) {
				const horsesSlider = new HorsesSlider($(el));
			});
		}

		// Newsletter form component
		const $newsletterFormElements = $(".footer-block.footer-block--newsletter-style");
		if ($newsletterFormElements.length) {
			$newsletterFormElements.each(function (index, el) {
				const newsletterForm = new NewsletterForm(el);
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}

		// Filtre des chevaux page catalogue
		$('.horses__filters select').change(function() {
			changeList();
		});


		function changeList() {
			var $horses = $(".horselist__link");
			if($horses.length) {
				var activeFilters = [$("#gender").val(), $("#year").val()].filter(function(value) {
					return value !== 'default';
				});
				if(activeFilters.length) {
					$horses.hide().filter('.' + activeFilters.join('.')).show();
				}
				else {
					$horses.show();
				}
			}
		}
	}

	bootstrapApp();
	instanciateComponents();

});

// })(jQuery);